import { render, staticRenderFns } from "./AuthenticatedFooter.vue?vue&type=template&id=11749638&"
import script from "./AuthenticatedFooter.vue?vue&type=script&lang=js&"
export * from "./AuthenticatedFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports